import { Navigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { DashboardModules } from './dashboard/DashboardModules';
import { useDashboardSnapshot } from './dashboard/useDashboardSnapshot';

export default function DashboardPage() {
  const { user, flags, loading, error, snapshot } = useDashboardSnapshot();

  if (user?.role === 'USER') {
    return <Navigate to='/chatbots' replace />;
  }

  const displayName = user?.email?.split('@')[0] ?? 'usuario';
  const isOperator = user?.role === 'OPERATOR';

  return (
    <div className='space-y-6'>
      <div>
        <h1 className='text-2xl font-semibold text-foreground'>Dashboard</h1>
        <p className='mt-1 text-muted-foreground'>
          Bienvenido, {displayName}. Resumen operativo de los módulos habilitados para tu tenant.
        </p>
      </div>

      {error ? (
        <Card>
          <CardContent className='py-4 text-sm text-destructive'>{error}</CardContent>
        </Card>
      ) : null}

      <DashboardModules
        flags={flags}
        isOperator={isOperator}
        snapshot={snapshot}
        loading={loading}
      />
    </div>
  );
}
